/* global Site */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';

// Import website components
import { Modal, ModalCancelButton, ModalSaveButton, ModalButtonGroup, Loading } from '../../components';


import { Fmsync } from '../../api';

import * as select from '../../reducers';
import * as actionsPrograms from '../../actions/programs';
import axios from '../../api/axios';

class RepledgeModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  state = {
    buttonType: '',
    values: {},
    message: '',
    errorMessage: '',
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    this.props.fetchPrograms(this.props.authedUserId).then((data) => {
      this.getDefaultValues(this.props.programs);
    });
  }

  sendSupport() {
    const { buttonType } = this.state;

    this.setState({ errorMessage: '' });

    if (buttonType === 'success') {
      this.props.onClose();
      return;
    }

    this.setState({ buttonType: 'saving' });
    const values = Object.values(this.state.values).filter((val) => {
      if (val.active) {
        return val;
      }
      return null;
    });

    const errors = Object.values(values).filter((val) => {
      if (parseFloat(val.value) < 10.0) {
        return true;
      }
      return null;
    });

    if (errors.length > 0) {
      this.setState({
        buttonType: 'error',
        errorMessage: 'Each support value needs to be $10 or greater.',
      });
      return;
    }

    const data = {
      support: values.map(charity => ({
        donation_recipient: charity.program.donation_recipient,
        donation_recipient_id: charity.program.donation_recipient_id,
        value: charity.value
      }))
    };

    axios.post('api/once-off', data)
      .then(() => {
        this.setState({
          buttonType: 'success',
          message: 'Thank you for your support. Your one-time top up payment will be processed within the next 24 hours.',
        });
      })
      .catch((e) => {
        if (e && 'errors' in e) {
          this.setState({
            buttonType: 'error',
            message: e.errors[0],
          });
        } else {
          this.setState({
            buttonType: 'error',
            errorMessage: 'An unknown error has occurred, please try again later',
          });
        }
      });
  }

  getDefaultValues = (programs) => {
    let values = {};
    programs.map((program) => {
      values[program.donation_id] = {
        program,
        active: true,
        value: parseFloat(program.donation_value).toFixed(2),
      };
    });

    this.setState({ values });
  };

  onChange = (event) => {
    const { values } = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name.replace('program_', '');
    values[name].value = value;
    this.setState({
      values,
    });
  };

  removeOption = (id) => {
    const { values } = this.state;

    values[id].active = false;
    this.setState({ values });

    let active = 0;
    Object.values(values).map((val) => {
      if (val.active) {
        active++;
      }
    });
    if (active === 0) {
      this.props.onClose();
    }
  };

  render() {
    const { onClose, programsLoading, programs } = this.props;
    const { buttonType, values, message, errorMessage } = this.state;

    if (Object.keys(values).length === 0 || programsLoading) {
      return <span />;
    }

    // If there is a selected program, return the modal allowing the user to edit the donation
    return (
      <form
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
          }
        }}
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Modal isOpen={true} modalName="edit-program" onClose={onClose}>
          <div className="remodal remodal--help" data-remodal-id="repledge-modal">
            <div className="help_content help_content--top form">
              {message === '' && (
                <div className="mb--24">
                  <p>Thank you for updating your expired credit card!</p>
                  <p>
                    Maybe some donations were unable to to be processed because your card had expired. Would you like to give a one-time top up donation now?
                  </p>
                </div>
              )}
              <div className="mb--32">
                {programsLoading && <Loading />}

                {message && <h3 className={'form__alert-box success'}>{message}</h3>}
                {errorMessage && <h3 className={'form__alert-box error'}>{errorMessage}</h3>}
                {message === '' &&
                  programs.map((program, idx) => {
                    return values[program.donation_id].active ? (
                      <div className="flex-row form__row" key={program.donation_id}>
                        <CurrencyInput
                          label={program.donation_recipient}
                          donation_id={program.donation_id}
                          step="1"
                          value={values[program.donation_id]["value"]}
                          onChange={this.onChange}
                          name={`program_${program.donation_id}`}
                          id={`program_${program.donation_id}`}
                          removeOption={this.removeOption}
                        />
                      </div>
                    ) : null;
                  })}
              </div>

              <div className="flex-row form__finalise-changes">
                <ModalButtonGroup>
                  {message === '' && (
                    <ModalCancelButton action="close" onClick={onClose}>
                      Cancel
                    </ModalCancelButton>
                  )}
                  <ModalSaveButton variant={buttonType} onClick={() => this.sendSupport()}>
                    Send Support
                  </ModalSaveButton>
                </ModalButtonGroup>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

const CurrencyInput = ({ donation_id, removeOption, ...rest }) => (
  <div className="form__row form__currency">
    <h3 className="mb--12" htmlFor={rest.id}>
      {rest.label}
    </h3>
    <div className="form_input_wrap">
      <div className="form_input_icon form_input_icon--dollar"></div>
      <input className="form_input" type="number" {...rest} />
      <a className="form_input_icon--close" onClick={() => removeOption(donation_id)}>
        <MdClose />
      </a>
    </div>
  </div>
);

const mapStateToProps = (state, ownProps) => {
  return {
    programs: select.getProgramsByPaymentType(state, 'Credit Card'),
    programsError: select.getProgramsError(state),
    programsLoading: select.getProgramsLoading(state),
    isAuthed: select.getIsLoggedIn(state),
    authedUserId: select.getSessionUserId(state),
  };
};

export default connect(mapStateToProps, {
  ...actionsPrograms,
})(RepledgeModal);
